import { type ReactElement } from 'react'
import { useAppSelector } from '@/store'
import { selectEnvironment } from '@/store/hederaSettingsSlice'
import SignOrExecuteFormV2 from './SignOrExecuteFormV2'
import HederaApproveExecuteForm from './HederaApproveExecuteForm'
import type { SignOrExecuteProps } from './SignOrExecuteFormV2'

export const SignOrExecuteFormV3 = (props: SignOrExecuteProps): ReactElement | undefined => {
  const environment = useAppSelector(selectEnvironment)

  if (environment === 'hedera') {
    return <HederaApproveExecuteForm {...props} />
  }

  return <SignOrExecuteFormV2 {...props} />
}

export default SignOrExecuteFormV3
